import * as React from 'react';

type EnterpriseLearningPathCurriculumModuleCountContextType = {
  // Key is course ID, value is number of modules in the course.
  courseModuleCounts: Record<string, number>;
  isLoading: boolean;
};

const EnterpriseLearningPathCurriculumModuleCountContext = React.createContext<
  EnterpriseLearningPathCurriculumModuleCountContextType | undefined
>(undefined);

export const useEnterpriseLearningPathCurriculumModuleCount = () => {
  const context = React.useContext(EnterpriseLearningPathCurriculumModuleCountContext);
  if (context === undefined) {
    throw new Error(
      'useEnterpriseLearningPathCurriculumModuleCount must be used within an EnterpriseLearningPathCurriculumModuleCountProvider'
    );
  }
  return context;
};

export default EnterpriseLearningPathCurriculumModuleCountContext;
